import { Directive, ElementRef, EventEmitter, Output, OnInit, inject } from '@angular/core';

@Directive({
  selector: '[googlePlacesAutocomplete]',
  standalone: false
})
export class GooglePlacesAutocompleteDirective implements OnInit {
  private el = inject<ElementRef<HTMLInputElement>>(ElementRef);


  @Output() placeSelected = new EventEmitter<any>();

  private autocomplete!: google.maps.places.Autocomplete;

  ngOnInit(): void {
    this.autocomplete = new google.maps.places.Autocomplete(
      this.el.nativeElement,
      {
        types: ['geocode'],
      }
    );

    this.autocomplete.addListener('place_changed', () => {
      this.placeSelected.emit(this.autocomplete.getPlace());
    });
  }
}
